import * as React from 'react';

const RefreshIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M16.6668 9.16634V3.33301L14.6668 5.24967C13.5002 4.08301 11.8335 3.33301 10.0002 3.33301C6.3335 3.33301 3.3335 6.33301 3.3335 9.99967C3.3335 13.6663 6.3335 16.6663 10.0002 16.6663C12.8173 16.6663 15.1727 14.9516 16.1865 12.5196C16.3864 12.0398 16.0339 11.5364 15.5167 11.4847C15.1183 11.4448 14.7528 11.6927 14.582 12.0549C13.7589 13.7993 12.0129 14.9997 10.0002 14.9997C7.25016 14.9997 5.00016 12.7497 5.00016 9.99967C5.00016 7.24967 7.25016 4.99967 10.0002 4.99967C11.3335 4.99967 12.5835 5.58301 13.5002 6.49967L11.2502 8.74967L16.6668 9.16634Z' />
		</svg>
	);
};

export default RefreshIcon;
